export const base = "https://web.devk8s.daory.net";
export const base_ws = "https://ws.devk8s.daory.net";
export const contract_address = "0x2b79f21B5a90aB2204cDb8163708F2077285329c";
export const bn_id = "cae96417-0f06-4935-864d-2d5f99e7d40f";
